import HttpFactory from '@/mixins/http.factory';
import download from "downloadjs";
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';

export default {
	name:'linked-tickets',
	mixins:[HttpFactory],
	data () {
		return {
			columnDefs:[],
			filters:{searchText:null},
			data:null,
			linkedTickets:[],
			gridOptionsApi:null
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.getData();
				}
			});
		},
		getData(){
			let _self=this;
			_self.fn().clearMessage();
			let data={auth:_self.zendeskInfo.credentials};

			var url=`linkedtickets/all`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				_self.linkedTickets=response.data.Data;
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		onGridOptionsApi(params){
            this.gridOptionsApi=params;
        },
        async filterData(){
            const _self=this;
            const searchText=_self.filters.searchText;
            _self.gridOptionsApi.api.setQuickFilter(searchText);
        },
		exportData(){
			let _self=this;
			let linkedTickets=_self.linkedTickets;
			_self.fn().sortNumCol(linkedTickets,'hdTicketId',true);
			let defaultNullVal='-';
			let fileName = `linked_tickets.csv`;
			let csvData = `Ticket #, Workitem #, Ticket URL, Workitem URL, Ticket Subject, Type, Project, Title, HD Status, Status, Assignee, WI Priority, WI Severity, WI Area, WI Found In, Description, WI CreatedOn, WI CreatedBy, WI ClosedOn, WI ClosedBy \r\n`;
      linkedTickets.forEach(function (item) {
        let wi_jsonCols = item.wi_jsonCols ? item.wi_jsonCols : null;
				if (!_self.fn().isJsonString(wi_jsonCols)) wi_jsonCols=null;
				  try {
					  wi_jsonCols = JSON.parse(wi_jsonCols);
        } catch (ex) { wi_jsonCols = null; }

				let row = `${_self.fn().formatCSV(item.hdTicketId?item.hdTicketId:defaultNullVal)},${_self.fn().formatCSV(item.workItemId?item.workItemId:defaultNullVal)},${_self.fn().formatCSV(item.hdTicketUrl?item.hdTicketUrl:defaultNullVal)},${_self.fn().formatCSV(item.workItemUrl?item.workItemUrl:defaultNullVal)},${_self.fn().formatCSV(item.hdSubject?item.hdSubject:defaultNullVal)},${_self.fn().formatCSV(item.workItemType?item.workItemType:defaultNullVal)},${_self.fn().formatCSV(item.projectName?item.projectName:defaultNullVal)},${_self.fn().formatCSV(item.devOpsTitle?item.devOpsTitle:defaultNullVal)},${_self.fn().formatCSV(item.hdStatus?item.hdStatus:defaultNullVal)},${_self.fn().formatCSV(item.status?item.status:defaultNullVal)},${_self.fn().formatCSV(item.assignedTo?item.assignedTo:defaultNullVal)},${_self.fn().formatCSV(item.wi_priority?item.wi_priority:defaultNullVal)},${_self.fn().formatCSV(wi_jsonCols && wi_jsonCols.severity?wi_jsonCols.severity:defaultNullVal)},${_self.fn().formatCSV(wi_jsonCols && wi_jsonCols.area?wi_jsonCols.area:defaultNullVal)},${_self.fn().formatCSV(item.wi_foundIn?item.wi_foundIn:defaultNullVal)},${_self.fn().formatCSV(item.description?item.description:defaultNullVal)},${_self.fn().formatCSV(item.wi_createdOn?_self.filter().formatDateTime(item.wi_createdOn):defaultNullVal)},${_self.fn().formatCSV(item.wi_createdBy?item.wi_createdBy:defaultNullVal)},${_self.fn().formatCSV(item.wi_closedOn?_self.filter().formatDateTime(item.wi_closedOn):defaultNullVal)},${_self.fn().formatCSV(item.wi_closedBy?item.wi_closedBy:defaultNullVal)}`;
				csvData += row + "\r\n";
			});
			download(csvData, fileName, 'data:application/csv;charset=utf-8');
		},
	},
	components:{
		customAgGrid
	},
	beforeMount() {
		let _self  =this;
		let commonWidth=150;//=120;
		_self.columnDefs = [
		  { headerName: 'Ticket #', field: 'hdTicketUrl', width: commonWidth,cellClass:'text-left',
		 	 cellRenderer:function(params){
				return `<a href="${params.value}" target="_blank">${params.data.hdTicketId}</a>`;
			}
		  },
		  { headerName: 'Subject', field: 'hdSubject',width: commonWidth },
		  { headerName: 'Workitem #', field: 'workItemUrl', width:100,
			cellRenderer:function(params){
				return `<a href="${params.value}" target="_blank">${params.data.workItemId}</a>`;
			}
		  },
		  { headerName: 'Type', field: 'workItemType',width: commonWidth },
		  { headerName: 'Project', field: 'projectName',width: commonWidth },
		  { headerName: 'Title', field: 'devOpsTitle',width: commonWidth },
		  { headerName: 'HD Status', field: 'hdStatus',width: commonWidth },
		  { headerName: 'Status', field: 'status',width: commonWidth },
		  { headerName: 'Assignee', field: 'assignedTo',width: commonWidth },
      { headerName: 'WI Priority', field: 'wi_priority', width: commonWidth },
      {headerName: 'WI Severity', field: 'wi_jsonCols', width: commonWidth,
			  cellRenderer: function (params) {
				  let wi_jsonCols = params.data.wi_jsonCols ? params.data.wi_jsonCols : null;
				  if (!wi_jsonCols) return null;
				  if (!_self.fn().isJsonString(wi_jsonCols)) return wi_jsonCols;
				  try {
					  let wi_jsonObj = JSON.parse(wi_jsonCols);
					  return wi_jsonObj.severity ? wi_jsonObj.severity:null;
				  }catch(ex){}
				  return null;
				}
			},
      {headerName: 'WI Area', field: 'wi_jsonCols', width: commonWidth,
			  cellRenderer: function (params) {
				  let wi_jsonCols = params.data.wi_jsonCols ? params.data.wi_jsonCols : null;
				  if (!wi_jsonCols) return null;
				  if (!_self.fn().isJsonString(wi_jsonCols)) return wi_jsonCols;
				  try {
					  let wi_jsonObj = JSON.parse(wi_jsonCols);
					  return wi_jsonObj.area ? wi_jsonObj.area:null;
				  }catch(ex){}
				  return null;
				}
			},
		  { headerName: 'WI Found In', field: 'wi_foundIn',width: commonWidth },

		  { headerName: 'WI Created On', field: 'wi_createdOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
		  { headerName: 'WI Created By', field: 'wi_createdBy',width: commonWidth },
		  { headerName: 'WI Closed On', field: 'wi_closedOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
		  { headerName: 'WI Closed By', field: 'wi_closedBy',width: commonWidth },

		  //{ headerName: 'Description', field: 'description',width: commonWidth },
		];
	}
}

